import { useEffect, useState } from 'react';
import { safeHtml } from '../lib/sanitize';

export default function FaqItem({ q, a, startOpen = false }){
  const [open, setOpen] = useState(startOpen);
  useEffect(() => {}, [open]);
  return (
    <div className={`faq-item ${open ? 'open' : ''} reveal`}>
      <button className="faq-q" onClick={() => setOpen(o => !o)} aria-expanded={open}>
        <span>{q}</span>
        <span className="icon" aria-hidden="true"></span>
      </button>
      <div className="faq-a" dangerouslySetInnerHTML={safeHtml(a)} />
    </div>
  );
}
